import React from 'react';
import * as DateFns from 'date-fns';
import FileSaver from 'file-saver';
import pako from 'pako';
import QueryString from 'query-string';
import { colors } from '../config/colors';
import {
  ALL,
  BALL,
  BY_PERIOD,
  CONDENSED,
  CONTROLLER_SET,
  CUSTOM_SCOPES,
  EXPANDED,
  FILTER_KEYS,
  FLIGHT,
  FLIGHTS,
  FORMAT_DATE_ROUTE,
  FUTURE_PRACTICE,
  GAME,
  GAMES,
  HEADERS,
  LABEL_DEFAULT_DAYS_COMPARE_TO_DATA,
  LEAGUE,
  LEAGUES,
  LIVE_DELAY_IN_SECS,
  LIVE_DIFFERENCE_STANDARD,
  LIVE_PRACTICE,
  MANAGE,
  MAP,
  PAST,
  PAST_PRACTICE,
  PERFORMANCE,
  PERIOD_END_LABEL,
  PERIOD_START_LABEL,
  PLAY_TYPE,
  PRACTICE,
  PRACTICE_PERIODS,
  PRACTICES,
  QUARTER,
  REPORT,
  S_B_ROLES,
  SCOPE,
  TRAILS_STORAGE_LIMIT,
  VENUE_LABELS,
  TEAMS_ALL, FILTER_GLOBAL_KEYS, ADD_ACTION, BALL_JERSEY, COMBINE, EVENT_END_LABEL, EVENT_START_LABEL, EVENT_LOGGER,
  GAME_MANAGE,
  PRACTICE_TRACKING,
  PAST_GAME
} from '../config/constants';
import { isEmptyObject, removeDecimalsFromSecs } from './commonHelpers';
import { logout as serviceLogout } from '../config/services/datasets';
import store from '../store';
import { CLEAN_ALL_STATE } from '../store/types';
import { getVenues, routeIsGame, routeToEventType, routeToScope } from './helpersts';

const emptyArray = [];
export const getTeamIdsList = (teams) => {
  const allTeamIds = {
    nfl: [],
    ncaa: teams.ncaa.map((team) => team.teamId)
  };
  Object.values(teams.nfl).forEach((division) => {
    division.forEach((subDivision) => {
      subDivision.teams.forEach((team) => {
        allTeamIds.nfl.push(team.teamId);
      });
    });
  });
  return allTeamIds;
};

/*
 Return all events of onlyDatePath filtered by teams and event type
 194 OSU Football, 19410 OSU Lacrosse, 9500 Zebra test team
 */
export const getEventsFromStateFromPath = (state, onlyDatePath) => {
  const groupIds = ['1000', '1001','1002', '1003', '1004', '1005', '1006', '1007', '1008', '1009', '1010', '1011','1020'];
  const checkBoxEvent = state.filters[CUSTOM_SCOPES.SCHEDULE] && state.filters[CUSTOM_SCOPES.SCHEDULE][FILTER_KEYS.EVENTS] ?
    state.filters[CUSTOM_SCOPES.SCHEDULE][FILTER_KEYS.EVENTS] :
    ALL;
  const ALL_TEAMS_IDS = getTeamIdsList(state.filters[FILTER_GLOBAL_KEYS.TEAMS] || { nfl: {}, ncaa: [] });
  let teamIds = state.filters[CUSTOM_SCOPES.SCHEDULE] && state.filters[CUSTOM_SCOPES.SCHEDULE][FILTER_KEYS.TEAM_IDS] && state.filters[CUSTOM_SCOPES.SCHEDULE][FILTER_KEYS.TEAM_IDS].length > 0 ?
    state.filters[CUSTOM_SCOPES.SCHEDULE][FILTER_KEYS.TEAM_IDS] :
    [...ALL_TEAMS_IDS.nfl, ...ALL_TEAMS_IDS.ncaa, '9500', ...groupIds];
  if (process.env.REACT_APP_ENV !== 'production') {
    teamIds = [...teamIds, '4501', '3701', '3301', '2701', '1541', '1051', '1201', '1801', '0811', '2511', '1194', '9500', '19411', ...groupIds];
  }
  const scope = routeToScope(onlyDatePath);
  const viewDate = routeToDate(onlyDatePath, 3);
  const nowDate = new Date();
  let today = false;
  if (scope === SCOPE.SCHEDULE.MONTH.PAGE) {
    if (DateFns.isSameMonth(viewDate, nowDate)) {
      today = true;
    }
  } else if (scope === SCOPE.SCHEDULE.WEEK.PAGE) {
    if (DateFns.isSameWeek(viewDate, nowDate)) {
      today = true;
    }
  }
  const scheduleScope = routeToScheduleScope(onlyDatePath);
  const filterByTeamIdsAndEvents = (event, lessToday) => {
    const show = teamIds.some((teamId) => (teamId === event.homeTeamId || teamId === event.visitorTeamId)) && ((lessToday && !DateFns.isToday(new Date(event.startTime))) || (!lessToday));
    if (checkBoxEvent === GAMES) {
      return show && event.type === GAME;
    }
    if (checkBoxEvent === PRACTICES) {
      return show && event.type === PRACTICE;
    }
    return show;
  };
  return state.events[scheduleScope] ? [
    ...state.events[scheduleScope].filter((event) => filterByTeamIdsAndEvents(event, true)),
    ...((today && state.events[SCOPE.SCHEDULE.TODAY]) ? state.events[SCOPE.SCHEDULE.TODAY].filter((event) => filterByTeamIdsAndEvents(event, false)) : [])] : emptyArray;
};

export const getEventsFromState = (state) => {
  const onlyDatePath = state.router.location.pathname.split('/').slice(0, 6).join('/');
  return getEventsFromStateFromPath(state, onlyDatePath);
};

export const renderCard = (events, currentHour, Component) => {
  let dayEvents = [];
  if (events) {
    dayEvents = events.map((event, index) => {
      const disabled = event.status === 'future';
      return DateFns.getHours(new Date(event.drills && event.drills.length > 0 && event.drills[0].startTs ? event.drills[0].startTs : event.startTime)) === currentHour ?
        <Component key={index} event={event} disabled={disabled} />
        : null;
    });
  }
  return dayEvents;
};

export const getIcon = (id) => {
  switch (id) {
    case 1:
      return 'Sunny';
    case 2:
    case 3:
    case 5:
      return 'Mostly_Sunny';
    case 4:
    case 6:
      return 'Partly_Cloudy';
    case 7:
    case 8:
      return 'Cloudy';
    case 11:
      return 'Foggy';
    case 12:
      return 'Showers';
    case 15:
      return 'T Storms';
    case 18:
      return 'Rain';
    case 22:
      return 'Snow';
    case 32:
      return 'Windy';
    default:
      return 'Cold';
  }
};

export const clearGames = (games) => {
  return games.filter(game => {
    if (game.type === PRACTICE) {
      return true;
    }
    if (game.isFuture) {
      return true;
    }
    if (!game.gameType || game.gameType === 'ncaa-fbs') {
      return true;
    }
    if (!game.startTime) {
      return false;
    }
    if (!game.homeTeamAbbr || !game.visitorTeamAbbr) {
      return false;
    }

    if (!game.score || !game.scheduledStartTimeEasern) {
      return false;
    }
    if (game.score.homeTeamScore && game.score.visitorTeamScore) {
      return !isNaN(game.score.homeTeamScore.pointTotal) && !isNaN(game.score.visitorTeamScore.pointTotal);
    }
    if(Object.keys(game.score).length === 0){
     return true;

    }
    return false;
  });
};

export const getTeamProps = (teamId) => { // OLD
  let teamProps = null;
  TEAMS_ALL.forEach((team) => {
    if (team.teamId === '' + teamId) {
      teamProps = team;
    }
  });
  return teamProps;
};

export const routeToScheduleScope = (route) => {
  const routes = route.split('/');
  const scope = routeToScope(route);
  if (routes[2] === 'week') {
    return scope + ':' + routes[3] + ':' + routes[4] + ':' + routes[5];
  }
  return scope + ':' + routes[3] + ':' + routes[4];
};

export const formatDateRoute = (nowDate) => (DateFns.format(new Date(nowDate), FORMAT_DATE_ROUTE));

export const routeToDate = (path, index) => {
  index = index ? index : 3;
  const params = path.split('/');
  if (!(Number.isNaN(+params[index]) || Number.isNaN(+params[index + 1]) || Number.isNaN(+params[index + 2]))) {
    return new Date(0 + params[index], +params[index + 1] - 1, 0 + params[index + 2], 0, 0, 0, 0);
  }
  const nowDate = new Date();
  return new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDay(), 0, 0, 0, 0);
};

export const routeIsPractice = (route) => {
  return routeToEventType(route) === PRACTICE;
};

export const prePathViewPage = (route) => {
  if (routeIsPractice(route)) {
    return routeToXFirstParams(route, 5);
  }
  if (routeIsGame(route)) {
    return routeToXFirstParams(route, 6);
  }
  return '/';
};

export const isRouteModalOpen = (path, event) => {
  const params = path.split('/');
  if (!(Number.isNaN(+params[7]) && params[6] !== 'modal')) {
    return +event.gameId === +params[7];
  }
  return false;
};

export const routeToXFirstParams = (path, x) => {
  const params = path.split('/');
  let route = '';
  for (let i = 1; i < params.length && i <= x; i++) {
    route = route.concat('/' + params[i]);
  }
  return route;
};

export const downloadFile = (file, type, fileName) => {
  const blobFile = new Blob([file], { type: `text/${type}` });
  FileSaver.saveAs(blobFile, fileName);
};

// export const getFile = async (dsId, teamId) => {
export const fileDownload = async (url, filename) => {
  const file = await fetch(url)
              .then((response)=>response.json());
  return file.code;
};

export const getFile = async (url, fileName, format) => {
  let error = false;
  const file = await fetch(url).catch(e => {
    console.error(e);
    error = true;
  });
  if (file && !error && file.ok) {
    const blob = await file.blob();
    downloadFile(blob, format ? format : 'csv', fileName);
    return true;
  }
  return false;
};

export const modalRoute = (path, event, disabled, user) => {
  if (event.status === 'future' && (isTA(user) || isNCAAAllSports(user))) {
    return `/view/practice/${event._id}/manage`;
  }
  if (event.live) {
    return `/view/practice/${event.gameId}/performance/condensed/page`;
  }
  if (isTA(user)) {
    return `/view/practice/${event.gameId}/performance/expanded/page`;
  }
  if (disabled || Number.isNaN(+event.gameId)) {
    return path;
  }
  return `/view/practice/${event.gameId}/performance/expanded/page`;
  //return `${path}/modal/${event.gameId}`;
};

export const scopeIsModalPlayer = (scope) => {
  return scope && scope.includes('MODAL');
};

export const selectedPracticeRoute = (path, event, user, liveBar, isMobile) => {
  if (event.type === GAME) {
    const isAway = !event.local;
    const teamId = (event.homeTeamId && event.homeTeamId !== '') &&
    (event.visitorTeamId && event.visitorTeamId !== '') ?
      !isAway ? event.homeTeamId : event.visitorTeamId :
      (event.homeTeamId && event.homeTeamId !== '') ?
        event.homeTeamId : event.visitorTeamId;
    return `/view/game/${event.gameId}/${teamId}/performance/expanded/page`;
  } else {
    const id = event.gameId === 'unassigned' ? event._id : event.gameId;
    if(isMobile && event.status === PAST){
      return `/view/practice/${id}/performance/condensed/page`;
    }else{
    if (isCC(user) || isTA(user) || isNCAAAllSports(user)) {
      if (event.status === PAST) {
        return `/view/practice/${id}/performance/expanded/page`;
      }
      if (liveBar) {
        return `/view/practice/${id}/performance/condensed/page`;
      }
      return `/view/practice/${id}/manage`;
    } else if (isTA(user) && event.live) {
      return `/view/practice/${id}/performance/condensed/page`;
    }
    return `/view/practice/${id}/performance/condensed/page`;
  }
  }
};

export const teamFullName = (teams, teamId) => {
  let fullName = '';
  for (const conference in teams.nfl) {
    // eslint-disable-next-line no-loop-func
    teams.nfl[conference].forEach((division, index) => {
      const team = division.teams.find((team) => (team.teamId === teamId));
      if (team) {
        fullName = team.teamFullName;
      }
    });
  }
  if (fullName !== '') {
    return fullName;
  }
  const team = (teams.ncaa ? teams.ncaa : []).find((team) => (team.teamId === teamId));
  if (team) {
    fullName = team.teamFullName;
  }
  return fullName;
};

export const cleanArrayControllers = (controllers) => {
  while (controllers.length > 0) {
    controllers.pop().abort();
  }
};

export const cleanControllerSet = controllerSet => {
  controllerSet.forEach(controller => {
    controller.abort();
  });
  controllerSet = new Set();
};

export const cleanFetch = () => {
  cleanControllerSet(CONTROLLER_SET);
  //cleanArrayControllers(CONTROLLERS);
};

export const isCC = user => user.sbRole === S_B_ROLES.COMMAND_CENTER;
export const isTA = user => user.sbRole === S_B_ROLES.TEAM_ADMIN;
export const isNCAA = user => (user.league === 'ncaa-fbs' || user.league === 'ncaa-mlax' || user.teamId === '194' || user.teamId === '19410') && user.sbRole !== S_B_ROLES.NCAA_ALL_SPORTS;
export const isNCAAAllSports = user => user.sbRole === S_B_ROLES.NCAA_ALL_SPORTS;
export const isOSULacrosse = teamId => +teamId === 19410;
export const isBrownsUser = user => user.teamId === '1050';
export const isMLAX = user => user.league === LEAGUES.MLAX;

export const identifyUser = response => {
  /*  CC,  ('*.*.*.*.w' )
  *   NFLTeamAdmin('nfl.practice.2700.*.w', 'nfl.game.2700.*.w'),
  *   NFLTeamAnalyst ('nfl.practice.2700.*.r'),
  *   OSUAllsports('ncaa-fbs.practice.194.*.w', 'ncaa-mlax.practice.19410.*.w'),
  *   OSUFootball ('ncaa-fbs.practice.2633.*.w')
  *   OSU MLAX ('ncaa-mlax.practice.19410.*.w') */
  // TODO Add permissions explanation
  const permissions = response.permissions.map(permission => permission.split('.'));
  let leagues = permissions.map(permission => permission[0]);
  leagues = [...new Set(leagues)]; //get unique leagues
  const isNcaaAllSports = leagues.includes('ncaa-fbs') && leagues.includes('ncaa-mlax'); // TODO use leagues constants
  let teamId = permissions[0][2];
  const teamRole = permissions[0][4];
  const league = leagues.join(','); // league=ncaa-mlax,ncaa-fbs
  let sbRole = '';
  let teamName = '';
  let teamShort = '';
  if (isNcaaAllSports) {
    sbRole = S_B_ROLES.NCAA_ALL_SPORTS;
  } else if (teamId === '*') { // * means all teams
    sbRole = S_B_ROLES.COMMAND_CENTER;
  } else if (teamRole === 'w') { // w write permission, r only read permission
    sbRole = S_B_ROLES.TEAM_ADMIN;
  } else {
    sbRole = S_B_ROLES.CUSTOMER;
  }
  if (teamId === '*') {
    teamName = 'Command Center';
    teamShort = 'CC';
    teamId = '2510'; // CC : 3701
  } else {
    const userTeam = TEAMS_ALL.find(team => team.teamId === teamId);
    teamName = userTeam.teamName;
    teamShort = userTeam.teamAbbr;
  }
  return {
    ...response.profileObj,
    isLogged: true,
    teamRole,
    league,
    tokenId: response.tokenId,
    id: response.id || null,
    insightRole: response.insightRole,
    permissions,
    teamName,
    teamShort,
    teamId,
    sbRole
  };
};

export const getVenueLabel = (league, type, teamId) => {
  return VENUE_LABELS[league][type][teamId];
};

export const getImageFilename = path => {
  const fileName = path.split('/').pop();
  // eslint-disable-next-line no-unused-vars
  const fileNameNoExtension = fileName.split('.');
};

export const practiceFieldUrlBuilder = field => {
  const id = field.id ? field.id : [];
  const teamId = field.teamId ? field.teamId : [];
  const areaName = field.areaName ? field.areaName : [];
  const x0 = field.x0 || field.x0 === 0 ? field.x0 : [];
  const y0 = field.y0 || field.y0 === 0 ? field.y0 : [];
  const x1 = field.x1 || field.x1 === 0 ? field.x1 : [];
  const y1 = field.y1 || field.y1 === 0 ? field.y1 : [];
  const type = field.type ? field.type : [];
  const lat = field.lat ? field.lat : [];
  const lng = field.lng ? field.lng : [];
  // const includeImage = field.includeImage ? field.includeImage : true;
  const heightFt = field.heightFt ? field.heightFt : [];
  const widthFt = field.widthFt ? field.widthFt : [];
  const paramObject = {
    id,
    teamId,
    areaName,
    x0,
    y0,
    x1,
    y1,
    type,
    lat,
    lng,
    // includeImage,
    heightFt,
    widthFt
  };
  return QueryString.stringify(paramObject, { arrayFormat: 'comma', encode: false });
};

export const paramBuilder = (params, isCondensed) => {

  const dateRanges = params.dateRange && params.dateRange.compareTo !== 'practices' ? params.dateRange.selectedDates : [];
  const strRanges = dateRanges.map(range => {
    return DateFns.format(new Date(range.start), 'yyyyMMdd') + '-' + DateFns.format(new Date(range.end), 'yyyyMMdd');
  });
  const compareDatasets = (params.dateRange && params.dateRange.compareTo === 'practices' && params.dateRange.selectedIdPractices) || [];
  const teamId = params.teamId ? params.teamId : [];
  const teamids = params.teamids ? params.teamids : [];
  const type = params.type ? params.type : [];
  const league = params.league ? params.league.value.value : [];
  const positions = params.positions ? params.positions.map((type) => type.value) : [];
  const quarters = params[QUARTER.filterKey] ? params[QUARTER.filterKey].map((type) => type.value) : [];
  const includePlayer = params.includePlayer ? params.includePlayer : [];
  const intensity = params[FILTER_KEYS.INTENSITY] ? params[FILTER_KEYS.INTENSITY].map((type) => type.value) : [];
  const flightType = params[FLIGHT.filterKey] ? params[FLIGHT.filterKey].map((type) => type.value).map(x => x.toLowerCase().replace(' ', '').replace('/', '')) : [];
  const periods = params[FILTER_KEYS.PERIODS] ? params[FILTER_KEYS.PERIODS].map((type) => type.value.session_id) : [];
  const timeSinceZone = params.timeSinceMax && params.timeSinceMax.zone && params.timeSinceMax.zone.value !== -1 ? params.timeSinceMax.zone.value : [];
  const timeSincePercentage = params.timeSinceMax && params.timeSinceMax.percentage !== -1 ? params.timeSinceMax.percentage : [];
  const playType = params[PLAY_TYPE.filterKey] ? params[PLAY_TYPE.filterKey].value.value : 'both';
  const viewMode = isCondensed? params.viewLive? params.viewLive.paramValue : [] : params.viewData ? params.viewData.paramValue : [];
  const gameView = params.gameView ? params.gameView : [];
  const tzOffset = params.tzOffset ? (params.tzOffset) : [];
  const atSecond = params.atSecond ? params.atSecond : [];
  const totalsOnly = params.totalsOnly ? params.totalsOnly : [];
  // modal player
  const entities = params.entities ? params.entities : [];
  const season = params.season ? params.season.value : [];
  const isGame = params.isGame ? params.isGame : [];
  const isPractice = params.isPractice ? params.isPractice : [];
  const teamOfInterest = params.teamOfInterest ? params.teamOfInterest : [];
  const includeTeams = params.includeTeams ? params.includeTeams : [];
  const isLive = params.isLive ? params.isLive : []; // to export csv live practices
  const compIntensity = params.compIntensity ? params.compIntensity : [];
  const prevGames = params.prevGames ? params.prevGames : [];
  const customCsv = params.customCsv ? params.customCsv : [];
  const paramObject = {
    teamId,
    league,
    includePlayer,
    compareRange: strRanges,
    compareDatasets,
    position: positions,
    quarter: quarters,
    intensity,
    periods,
    flightType,
    entities,
    inplay: playType,
    monitorspeedzone: timeSinceZone,
    monitorspeedpercentofmax: timeSincePercentage,
    viewMode,
    gameView,
    season,
    tzOffset,
    teamids,
    type,
    atSecond,
    totalsOnly,
    isGame,
    isPractice,
    teamOfInterest,
    includeTeams,
    isLive,
    customCsv,
    compIntensity,
    prevGames
  };
  return QueryString.stringify(paramObject, { arrayFormat: 'comma', encode: false }); // []
};

export const timeDifferenceHours = (later, earlier) => {
  const laterSeconds = DateFns.getHours(later) * 3600 + DateFns.getMinutes(later) * 60 +
    DateFns.getSeconds(later);
  const earlierSeconds = DateFns.getHours(earlier) * 3600 + DateFns.getMinutes(earlier) * 60 +
    DateFns.getSeconds(earlier);
  let seconds = Math.abs(laterSeconds - earlierSeconds);
  const hours = (seconds / 3600) >> 0;
  seconds -= 3600 * hours;
  const minutes = (seconds / 60) >> 0;
  seconds -= 60 * minutes;

  let result = new Date();
  result = DateFns.setHours(result, hours);
  result = DateFns.setMinutes(result, minutes);
  result = DateFns.setSeconds(result, seconds);

  return result * (laterSeconds < earlierSeconds ? -1 : 1);
};

export const saveDataEventsOnLocalStorage = (gameIds) => {
  const reducer = 'dataEvents';
  const recoveredStore = JSON.parse(localStorage.getItem('store')) || {};
  if (!recoveredStore[reducer]) {
    recoveredStore[reducer] = {};
  }
  for (const gameId of gameIds) {
    if (!recoveredStore[reducer][gameId]) {
      recoveredStore[reducer][gameId] = {};
    }
    if (store.getState()[reducer][gameId]) {
      recoveredStore[reducer][gameId].meta = store.getState()[reducer][gameId].meta;
    }
  }
  localStorage.setItem('store', JSON.stringify(recoveredStore));
};

export const saveDataPlayersOnLocalStorage = () => {
  const reducer = 'dataPlayers';
  const recoveredStore = JSON.parse(localStorage.getItem('store')) || {};
  recoveredStore[reducer] = store.getState()[reducer];
  localStorage.setItem('store', JSON.stringify(recoveredStore));
};

export const isDataEventsOnLocalStorage = (id) => {
  const reducer = 'dataEvents';
  const recoveredStore = JSON.parse(localStorage.getItem('store')) || {};
  if (recoveredStore[reducer] && recoveredStore[reducer][id]) {
    return true;
  }
};

export const loadDataPlayersOfLocalStorageIf = (playerId) => {
  const reducer = 'dataPlayers';
  const recoveredStore = JSON.parse(localStorage.getItem('store')) || {};
  return !!(recoveredStore[reducer] && recoveredStore[reducer][playerId]);
};

export const findMex = (set) => {
  let mex = 0;
  while (set.indexOf(mex) !== -1) {
    mex++;
  }
  return mex;
};

export const containsBadCharacter = (str) => {
  for (let i = 0; i < str.length; ++i) {
    if ((str[i] >= 'a' && str[i] <= 'z') || (str[i] >= 'A' && str[i] <= 'Z') || (str[i] >= '0' && str[i] <= '9')
      || str[i] === ' ' || str[i] === '_' || str[i] === '-' || str[i] === '–') {

      continue;
    } else {
      return true;
    }
  }
  return false;
};

let lastId = 0;
export const newIdGenerated = (prefix = 'id-generated-') => {
  lastId++;
  return `${prefix}${lastId}`;
};

export const fixLeague = (league) => {
  if (league === '*') {
    return 'ncaa-fbs,ncaa-mlax,nfl';
  }
  return league;
};

export const logout = (history, logoutGoogle) => {
  store.dispatch({ type: CLEAN_ALL_STATE });
  localStorage.clear();
  history.push('/');
  serviceLogout();
  logoutGoogle();
};

export const viewPathParams = (path) => {
  const params = path.split('/').slice(1);
  return {
    id: params.length > 2 ? params[2] : undefined,
    tab: params.length > 3 ? params[3] : undefined,
    subTab: params.length > 4 ? params[4] : undefined,
    modal: params.length > 5 ? params[5] : undefined
  };
};

export const getTabSelectorLabel = params => {
  if (params.tab === PERFORMANCE) {
    if (params.subTab === EXPANDED) {
      return 'All Metrics';
    } else if (params.subTab === CONDENSED) {
      return 'Live Metrics';
    } else if (params.subTab === BY_PERIOD && params.view === EXPANDED) {
      return 'All Metrics';
    } else if (params.subTab === BY_PERIOD && params.view === CONDENSED) {
      return 'Live Metrics';
    }
  }
  if (params.tab === BALL && params.subTab === FLIGHTS) {
    return 'Ball Metrics';
  }
  if (params.tab === REPORT) {
    return 'Reporting';
  }
  if (params.tab === COMBINE) {
    return 'Combine Logger';
  }
  if (params.tab === EVENT_LOGGER){
    return 'Event Logger';
  }
  if (params.tab === MANAGE) {
    return 'Practice Manager';
  }
  if (params.tab === GAME_MANAGE) {
    return 'Game Manager';
  }
  if (params.tab === MAP) {
    return 'Practice Viewer';
  }
  if (params.tab === PRACTICE_TRACKING) {
    return 'Practice Tracking';
}
  return undefined;
};

export const formatStringToNumber = (str, digitsAfterPoint) => {
  const splitted = str.split('.');
  splitted[0] = String(+splitted[0]);
  if (splitted.length > 1) {
    if (splitted.length === 2) {
      return splitted[0] + '.' + (digitsAfterPoint && Number.isInteger(digitsAfterPoint) ?
        (splitted[1].length < digitsAfterPoint ? splitted[1] : splitted[1].substr(0, digitsAfterPoint)) :
        splitted[1]);
    } else {
      return false;
    }
  } else {
    return splitted[0];
  }
};

export const findLeagueOptionFilter = (league, type) => {
  const foundLeague = LEAGUE.types.find(leagueType => {
    return leagueType.value.value === league && leagueType.value.type === type;
  });
  return foundLeague;
};

export const findVenueOptionFilter = (venues, league, type, teamId) => {
  const typeFilter = getVenues(venues, league, type);
  const defaultVenue = typeFilter.find(venue => venue.teamId === teamId);
  return defaultVenue ? {
    value: defaultVenue,
    name: defaultVenue.label ? defaultVenue.label : `(${defaultVenue.teamId ? defaultVenue.teamId : '-'}) ${defaultVenue.siteName}`
  } : undefined;
};

export const getRealTimeActualSeconds = startTime => {
  const actualTs = Date.now();
  const liveTime = actualTs - (1000 * LIVE_DELAY_IN_SECS); // n secs before actual time
  const actualTime = liveTime < startTime ? startTime : liveTime;
  const actualSeconds = Math.round(((actualTime - startTime) / 1000) * 10);
  return { actualTime, actualSeconds };
};

export const getKeyMetricFromHeaderAllMetrics = header => {
  let metricFound = null;
  for (const keyMetric in HEADERS) {
    if (HEADERS[keyMetric].LABEL.ALL === header) {
      metricFound = HEADERS[keyMetric].KEY;
      break;
    }
  }
  return metricFound;
};
export const getKeyMetricFromHeaderLiveMetrics = header => {
  let metricFound = null;
  for (const keyMetric in HEADERS) {
    if (HEADERS[keyMetric].LABEL.LIVE === header) {
      metricFound = HEADERS[keyMetric].KEY;
      break;
    }
  }
  return metricFound;
};

export const getMetricLabelFromHeaderLiveMetrics = metric => {
  let metricFound = null;
  for (const keyMetric in HEADERS) {
    if (HEADERS[keyMetric].KEY === metric) {
      if(Object.keys(HEADERS[keyMetric].FULL_NAME).length !== 2){
        metricFound = HEADERS[keyMetric].FULL_NAME;
        break;
      }else{
        metricFound = HEADERS[keyMetric].FULL_NAME.ALL;
        break;
      }
    }
  }
  return metricFound;
};

export const shouldDisplayPracticeViewer = data => {
  return (
    data.meta.type === LIVE_PRACTICE ||
    ((DateFns.isToday(data.meta.startTime) && data.meta.type !== FUTURE_PRACTICE) || (DateFns.isToday(data.meta.startTime) && data.meta.gameType === "ncaa"))
  );
};

export const getTimelinePosition = (slider, second, maxValue) => {
  if (slider && slider.current) {
    // Setting width after multiple testing to get the perfect size of the Timeline
    const timelineWidth = slider.current.offsetWidth - 10;
    const periodTimeline = (second * timelineWidth) / maxValue;
    return maxValue ? periodTimeline : 0;
  }
};

export const getActiveTiming = currentSec => {
  const secs = ~~(currentSec / 10);
  const decs = (currentSec % 10) * 10;
  return { secs, decs };
};

export const checkIfPlayerIsSelected = (pinnedRows, playerId) => {
  return pinnedRows && pinnedRows.length && pinnedRows.includes(playerId);
};

export const isPracticeLaunchedFromDataOps = progressStatus => progressStatus[0] === colors.finished;

const _arrayBufferToBase64 = buffer => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return atob(btoa(binary));
};

export const unZipBase64String = base64 => {
  const binary_string = atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  const binData = new Uint8Array(bytes);
  const data = pako.inflate(binData);
  const strData = _arrayBufferToBase64(data);
  return strData;
};

export const shouldTrailPlayer = (playerTrails, playerId) => {
  if (playerTrails && playerTrails[playerId] && Object.keys(playerTrails[playerId]).length) {
    return Object.entries(playerTrails[playerId]);
  } else {
    return [];
  }
};

export const removeTrailsIfExceed = playerTrails => {
  if (Object.keys(playerTrails).length >= TRAILS_STORAGE_LIMIT) {
    const firstKey = Object.keys(playerTrails)[0];
    delete playerTrails[firstKey];
  }
  return playerTrails;
};

export const checkOnProgressivePeriodChange = (currentSec, practiceData, currentPeriod, setCurrentPeriod) => {
  const { startTime, drills } = practiceData;
  if (drills && drills.length > 1) {
    const actualTime = startTime + (removeDecimalsFromSecs(currentSec) * 1000);
    if (drills[currentPeriod].endTs < actualTime && drills[currentPeriod + 1] && drills[currentPeriod + 1].startTs) {
      const newPeriod = currentPeriod < drills.length - 1 ? currentPeriod + 1 : currentPeriod;
      if (newPeriod !== currentPeriod) setCurrentPeriod(newPeriod);
    }
  }
};

export const getPracticeViewerStartTime = (practiceData, currentSec, setOnPlay, setCurrentSec, liveCurrentSec) => {
  const { startTime, type } = practiceData;
  if ((type === LIVE_PRACTICE || type === PAST_GAME) && (!liveCurrentSec || !isNotCurrentlyLive(currentSec, liveCurrentSec))) {
    const { actualTime, actualSeconds } = getRealTimeActualSeconds(startTime);
    setOnPlay(true);
    setCurrentSec(actualSeconds);
    return actualTime;
  } else {
    const actualSec = currentSec > 0 ? removeDecimalsFromSecs(currentSec) : currentSec;
    return startTime + (actualSec * 1000);
  }
};

export const isNotCurrentlyLive = (currentSec, liveCurrentSec) => {
  return currentSec < (liveCurrentSec - LIVE_DIFFERENCE_STANDARD);
};

const getTeamLeagueAbbrevation = league => {
  switch (league) {
    case LEAGUES.NFL:
      return league.toUpperCase();
    case LEAGUES.MLAX:
      return 'MLAX';
    case LEAGUES.NCAA:
      return 'FBS';
    default:
      return '';
  }
};

export const getTeamsDropdownLabel = (teamId, venue) => {
  if (teamId === -1 || !teamId) {
    return 'Select';
  } else {
    const { teamAbbrName, league } = venue;
    const teamAbbr = teamAbbrName ? teamAbbrName : (teamId === '9500' ? 'ZBRA' : 'TEST');
    const teamLeague = getTeamLeagueAbbrevation(league);
    return `${teamAbbr} (${teamId}) ${teamLeague}`;
  }
};

export const isHealthScopeChecker = scope => {
  return scope.substr(0, 6) === 'HEALTH';
};

export const getPracticeAreaHeader = (action, field) => {
  return action === ADD_ACTION ? 'Adding a new Practice Area' : `Editing "${field && field.areaName}" Area`;
};

export const isPVBall = player => {
  return player.name === BALL || player.jersey === BALL_JERSEY;
};

export const isTMSavable = periodsValidation => {
  return isEmptyObject(periodsValidation[PERIOD_START_LABEL]) &&
    isEmptyObject(periodsValidation[PERIOD_END_LABEL]);
};

export const isTMSavableCombine = periodsValidation => {
  return isEmptyObject(periodsValidation[EVENT_START_LABEL]) &&
    isEmptyObject(periodsValidation[EVENT_END_LABEL]);
};

export const filterPeriodTypesByUser = league => {
  const { user } = store.getState();
  if (isNCAA(user) || isNCAAAllSports(user) || (league && league !== LEAGUES.NFL)) {
    const unmutedPeriods = { ...PRACTICE_PERIODS };
    const types = PRACTICE_PERIODS.types.filter(type => type.substring(0, 3) !== 'NFL');
    return { ...unmutedPeriods, types };
  }
  return PRACTICE_PERIODS;
};

const getDate = (date) => {
  const da = new Date(date);
  return DateFns.format(da, 'MM/dd/yyyy');
};

export const getFiltersDateCompareLabel = (selectedData, specificScope) => {
  if (selectedData.compareTo === 'practices') {
    return `Practices (${selectedData.selectedIdPractices.length})`;
  }
  return (
    selectedData.default === LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[0].days && specificScope !== SCOPE.DATAOPS.PAGE ? LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[0].label :
      selectedData.default === LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[1].days && specificScope !== SCOPE.DATAOPS.PAGE ? LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[1].label :
        selectedData.default === LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[2].days && specificScope !== SCOPE.DATAOPS.PAGE ? LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[2].label :
          selectedData.default === 'currentYear' ? DateFns.getYear(new Date()) :
            (selectedData.default === 'custom' ||
            selectedData.default === LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[0].days ||
            selectedData.default === LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[1].days ||
            selectedData.default === LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[2].days) && specificScope === SCOPE.DATAOPS.PAGE ?
              (getDate((selectedData.selectedDates[0].start)) + ' - ' + getDate((selectedData.selectedDates[0].end))) :
              selectedData.default === 'custom' && specificScope !== SCOPE.DATAOPS.PAGE ?
                'Custom' : 'Select a Date Range'
  );
};
/**
 * This function returns the season year according to NFL calendar
 * @param {boolean} isNcaa false if the user is NFL, true if the user is NCAA
 * @returns number YYYY
 */
export const getCurrentSeasonYear = (isNcaa) => {
  const today = new Date();
  if (DateFns.getMonth(today) < 2 && !isNcaa) {
    return today.getFullYear() - 1;
  }
  return today.getFullYear();
};


export const shouldDisplayDeletePracticeButton = (user, practice) => {
  if (practice.meta.type === FUTURE_PRACTICE) {
    return true;
  } else if (practice.meta.type === LIVE_PRACTICE) {
    return false;
  } else if (practice.meta.type === PAST_PRACTICE && isCC(user)) {
    return true;
  }
  return false;
};

export const getPracticeHeadData = (scope, data, filteredPos, filteredStatus, playerparticipation) => {
  const viewingManage = scope === SCOPE.VIEW.PRACTICE.MANAGE.PAGE;
  const isPracticeViewer = scope === SCOPE.VIEW.PRACTICE.MAP.PAGE;
  const ballCount = filteredPos && filteredPos.length?
    data.playersBall.filter((player) => filteredPos.includes(player.position)).length : data.playersBall.length;
  const manageData = viewingManage && data && data.manage ? data.manage : undefined;
  const filteredPlayers = filteredPos && filteredPos.length?
    data.players.filter((player) => filteredPos.includes(player.position))
      : data.players;
  const participationPlayersStatus = playerparticipation && playerparticipation.length?
  filteredStatus && filteredStatus.length ? playerparticipation.filter((player) => filteredStatus.includes(player.status)) : playerparticipation : 0;
  const participationPlayers = participationPlayersStatus? filteredPos && filteredPos.length?
  participationPlayersStatus.filter((player) => filteredPos.includes(player.position))
    : participationPlayersStatus : 0;
  const participationCount = participationPlayers.length;
  const playersCount = !isPracticeViewer
    ? filteredPlayers.length
    : data.practiceViewer.players && data.practiceViewer.players.length;

  return { manageData, playersCount, ballCount, participationCount };
};

export const getPlayerBallMetricsState = (dataEvent, playerId) => {
  const modalPlayers = dataEvent.modalPlayers[playerId];
  return {
    type: dataEvent.meta.type,
    teamId: dataEvent.meta.homeTeam.teamId,
    playerData: modalPlayers,
    playerBallData: dataEvent.modalBallMetrics[playerId],
    velocityGraphData: modalPlayers && modalPlayers.velocityGraphData
  };
};

export const isSafeImageUrl = (url) => {
  if (typeof url !== 'string') return false;

  const trimmed = url.trim();

  // Block dangerous protocols explicitly
  const dangerous = /^(javascript|data:text|vbscript|file):/i;
  if (dangerous.test(trimmed)) return false;

  // Allow base64 encoded images only
  const base64ImagePattern =
    /^data:image\/(png|jpeg|jpg|webp);base64,[A-Za-z0-9+/=]+$/;
  if (base64ImagePattern.test(trimmed)) return true;

  // Allow local asset paths
  const isLocalPath =
    trimmed.startsWith('/assets/images/') &&
    !trimmed.includes('..') &&
    !trimmed.includes('\0') &&
    !trimmed.includes('?') &&
    /^[a-zA-Z0-9/_\-\.]+$/.test(trimmed);

  if (isLocalPath) return true;

  // Allow any http/https URL
  try {
    const parsed = new URL(trimmed);
    if (!['http:', 'https:', 'blob:'].includes(parsed.protocol)) return false;
    if (trimmed.includes('\0')) return false;
    return true;
  } catch {
    return false;
  }
};
export const simplifyRole = role => {
  if (role.includes("Admin")) return "Admin";
  if (role.includes("User") || role.includes("Analyst")) return "User";
  return "Partner";
};
